import { endsWith } from 'lodash';
import camelCase from 'lodash/camelCase';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import snakeCase from 'lodash/snakeCase';
import transform from 'lodash/transform';

export const snakeToCamelCase = (obj: any): any => {
  return transform(obj, (acc: any, value: any, key: any, target: any) => {
    const camelKey = isArray(target) ? key : camelCase(key);

    acc[camelKey] = isObject(value) ? snakeToCamelCase(value) : value;
  });
};

export const camelToSnakeCase = (obj: any) => {
  return transform(obj, (acc: any, value: any, key: any, target: any) => {
    const camelKey = isArray(target) ? key : snakeCase(key);

    acc[camelKey] = isObject(value) ? camelToSnakeCase(value) : value;
  });
};

/**
 * Converts a JSON object to FormData.
 * @param data - The JSON object to be converted.
 * @param formData - The FormData instance to append the data to.
 * @param parentKey - The key of the parent element in a nested structure.
 * @returns A FormData instance populated with the JSON data.
 */
export const jsonToFormData = (
  data: Record<string, any>,
  formData: FormData = new FormData(),
  parentKey: string | null = null
): FormData => {
  if (
    data &&
    typeof data === 'object' &&
    !(data instanceof Date) &&
    !(data instanceof File) &&
    !(data instanceof Blob)
  ) {
    Object.keys(data).forEach((key) => {
      const keyName = parentKey ? `${parentKey}[${key}]` : key;
      if (endsWith(key, '_ids') && Array.isArray(data[key])) {
        data[key].forEach((value: any) => {
          formData.append(`${keyName}[]`, value);
        });
      } else {
        jsonToFormData(data[key], formData, keyName);
      }
    });
  } else {
    if (parentKey) {
      if (data instanceof File || data instanceof Blob) {
        formData.append(parentKey, data);
      } else if (Array.isArray(data)) {
        data.forEach((value, index) => {
          formData.append(`${parentKey}[${index}]`, value);
        });
      } else {
        formData.append(parentKey, data != null ? data.toString() : '');
      }
    }
  }

  return formData;
};
